import { lazy } from 'react';

const UsPage = lazy(() => import('../pages/Us.page'));

const UsRoutes = [
    {
        path: '/us',
        element: <UsPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { UsRoutes };
